export default {
      id: "note-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#note",
      toString: function () {
        return this.url;
      }
    }